import { useEffect, useRef } from 'react';
import { RELECTURE_MS, RELECTURE_DUREE_MAX_MS } from '../constants/diffusionAttente';

/**
 * Lot BM — pendant que SeLoger traite un dépôt, on relit NOTRE api toutes les 30 secondes,
 * 10 minutes au maximum. Aucun sondage du portail : c'est son webhook qui nous met à jour,
 * l'écran ne fait que relire ce que nous avons déjà enregistré.
 *
 * ⚠️ Piège du lot AA (boucle de rechargement) : la fonction de relecture est gardée dans une
 * `ref` et n'entre PAS dans les dépendances de l'effet — sinon chaque donnée relue recréerait
 * l'intervalle. `actif` est un booléen, pas un objet.
 */
export const useRelectureDiffusion = (actif, relire) => {
  const relireRef = useRef(relire);
  relireRef.current = relire;

  useEffect(() => {
    if (!actif) return undefined;
    const debut = Date.now();
    const minuterie = setInterval(() => {
      if (Date.now() - debut >= RELECTURE_DUREE_MAX_MS) {
        clearInterval(minuterie);
        return;
      }
      if (typeof relireRef.current === 'function') relireRef.current();
    }, RELECTURE_MS);
    return () => clearInterval(minuterie);
  }, [actif]);
};

export default useRelectureDiffusion;
